import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import GenericButton from '../../../../Components/GenericButton/GenericButton';
import './PriceCompare.scss';
import { useTranslation } from 'react-i18next';

const PriceCompare = () => {
  const [viewEstimateCost, setviewEstimateCost] = useState(false);
  const { Features_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const FEATURES = Features_Setting;

  useEffect(() => {
    const estimateCostFlag = FEATURES?.find(
      (feature) => feature.Name === 'EstimateCostMember',
    );
    estimateCostFlag && estimateCostFlag.Status === true
      ? setviewEstimateCost(true)
      : setviewEstimateCost(false);
  }, []);
  const { t } = useTranslation();
  if (viewEstimateCost) {
    return (
      <Card className="price-compare-container">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="price-compare-title">
            {t('member.dashboard.price_compare.heading')}
          </h3>
        </div>
        <div className="price-compare-button-wrapper">
          <Link
            to="/member/price-compare"
            aria-label={
              'click to ' +
              t('member.dashboard.price_compare.price_compare_button')
            }
          >
            <GenericButton
              className="price-compare-button"
              variant="secondary"
              tabIndex={0}
            >
              {t('member.dashboard.price_compare.price_compare_button')}
            </GenericButton>
          </Link>
        </div>
        <div className="price-compare">
          <Card.Body className="price-compare-card-body">
            <div className="price-compare-info" role="button" tabIndex={0}>
              {t('member.dashboard.price_compare.price_info_para1')}
              <div className="second-para">
                {t('member.dashboard.price_compare.price_info_para2')}
              </div>
            </div>
          </Card.Body>
        </div>
      </Card>
    );
  }
};

export default PriceCompare;
